import React, { useState } from 'react'
import  { Redirect } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { TextField, Button, Grid, Paper, CircularProgress, IconButton, InputAdornment } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import Navbar from '../Components/NavBar/NavBar'
import { validateSession } from '../utils'
import { changePassword } from '../services/users/changePassword'
import logo from '../Files/entelai-doc.svg'


const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: "center",
    marginTop: '10%',
  },
  paper: {
    width: "25%",
    borderRadius: "3%",
    boxShadow: "0 2px 5px",
    margin: "0 auto",
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
}));

export default function ChangePassword() {
  let validator = window.location.search.substring(1).match('validator=') ? window.location.search.substring(1).replace('validator=', '') : ''
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => {
    setShowPassword(prevState => !prevState)
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChangePassword = async () => {
    setLoading(true)
    if (newPassword && confirmPassword){
      if (newPassword === confirmPassword){
        try {
          const response = await changePassword({'newPassword': newPassword, 'validator': validator})
          if (response.status === 200) {
            alert('La contraseña fue cambiada con exito')
            setLoading(false)
            window.location.replace('/metabase')
          } else{
            throw new Error()
          }
        } catch (error) {
          alert('Hubo un problema al intentar cambiar su contraseña.')
          setNewPassword('')
          setConfirmPassword('')
          setLoading(false)
        }
      } else{
        alert('Las contraseñas no coinciden')
        setConfirmPassword('')
        setLoading(false)
      }
    } else{
      alert('Ingrese todos los datos')
      setLoading(false)
    }
  }

  const classes = useStyles();

  return (
    <>
      {validator ? '' : !validateSession() ? <Redirect to="/login" />  : ''}
      {!validator && <Navbar />}
      <div className={classes.root}>
        <Grid container >
          <Paper className={classes.paper}>
            <Grid item xs={12}>
              <img src={logo} alt='Entelai Edoc' width="100%" />
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="newPassword"
                label="Nueva Contraseña"
                variant="outlined"
                type={showPassword ? 'text' : 'password'}
                fullWidth
                style={{marginTop: '12px'}}
                value={newPassword}
                onChange={({target}) => setNewPassword(target.value)}
                onKeyPress={async (e) => { if (e.key === 'Enter'){await handleChangePassword()}}}
                InputProps={{
                  endAdornment: <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField 
              name="confirmPassword"
              label="Confirmar Contraseña"
              variant="outlined"
              type={showPassword ? 'text' : 'password'}
              fullWidth
              style={{marginTop: '12px'}}
              value={confirmPassword}
              onChange={({target}) => setConfirmPassword(target.value)}
              onKeyPress={async (e) => { if (e.key === 'Enter'){await handleChangePassword()}}}
              InputProps={{
                endAdornment: <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }}
            />
            </Grid>
            <Grid item xs={12}>
              {loading && <CircularProgress style={{marginTop: '12px', marginLeft: '44%'}}/>}
              {!loading && <Button variant="contained" color="primary" style={{marginTop: '12px', width: '100%'}} onClick={async () => { await handleChangePassword() }}>
                CAMBIAR CONTRASEÑA
              </Button>}
            </Grid>
          </Paper>
        </Grid>
      </div>
    </>
  );
}
